import Swiper, { Autoplay, EffectFade, Navigation } from 'swiper';

import '../sass/citrus-image-carousel.scss';

(() => {
    const $citrusImageCarousels = document.querySelectorAll('.citrus-image-carousel');

    if (!$citrusImageCarousels) return;

    $citrusImageCarousels.forEach($citrusImageCarousel => {
        const $carousel = $citrusImageCarousel.querySelector('.citrus-image-carousel__carousel');
        const $paginationBullets = $citrusImageCarousel.querySelectorAll('.citrus-image-carousel__pagination-bullet');
        const $navigationNext = $citrusImageCarousel.querySelector('.citrus-image-carousel__navigation--next');
        const $navigationPrev = $citrusImageCarousel.querySelector('.citrus-image-carousel__navigation--prev');

        console.log($navigationNext, $navigationPrev);

        let carousel = null;

        const carouselAutoplayObserver = new IntersectionObserver(entries => {
            if (!entries || !carousel) return;

            entries.forEach(entry => {
                if (entry.isIntersecting && !carousel?.autoplay?.running) {
                    carousel.autoplay.start();
                }

                if (!entry.isIntersecting && carousel?.autoplay?.running) {
                    carousel.autoplay.stop();
                    carousel.slideTo(0);
                }
            });
        }, {
            threshold: 0.5
        });
    
        const initCarousel = () => {
            if (!$carousel) return;

            carousel = new Swiper($carousel, {
                modules: [ Autoplay, EffectFade, Navigation ],
                effect: $carousel?.dataset?.transitionType ?? 'fade',
                fadeEffect: {
                    crossFade: false
                },
                autoplay: $carousel?.dataset?.transitionType === 'fade' ? {
                    delay: 2000,
                } : false,
                speed: $carousel?.dataset?.transitionType === 'fade' ? 1000 : 300,
                allowTouchMove: $carousel?.dataset?.transitionType === 'slide',
                pauseOnMouseEnter: false,
                navigation: {
                    nextEl: $navigationNext ?? null,
                    prevEl: $navigationPrev ?? null,
                },
            });

            carousel.autoplay.stop();

            carouselAutoplayObserver.observe($citrusImageCarousel);

            if ($paginationBullets) {
                carousel.on('realIndexChange', swiper => {
                    $paginationBullets.forEach(($paginationBullet, index) => {
                        const { activeClasses, inactiveClasses } = $paginationBullet.dataset;
                        
                        $paginationBullet.classList = index === swiper?.realIndex ? activeClasses : inactiveClasses;
                    });
                });
            }
        };

        initCarousel();
    });
})();
